import type { CSSProperties } from 'react';
import type { Message } from '../chat-types';
import type { BlurRegion, ToolSessionSummary } from './types';

export const filterRenderableMessages = (messages: Message[]): Message[] =>
  messages.filter(
    (message) =>
      // Keep synthetic bootstrap/system chatter out of the visible transcript while still letting the model consume it.
      message.visibility !== 'hidden' && !(message.role === 'system' && message.id.startsWith('context-'))
  );

export const computeBlurMaskStyle = (blurRegion: BlurRegion | null): CSSProperties | undefined => {
  if (!blurRegion) {
    return;
  }
  const mask = 'radial-gradient(120% 140% at 50% 48%, transparent 0%, black 30%, black 70%, transparent 100%)';
  return {
    maskImage: mask,
    WebkitMaskImage: mask,
  } satisfies CSSProperties;
};

export const collectActiveToolSessions = (messages: Message[]): ToolSessionSummary[] => {
  const sessions: ToolSessionSummary[] = [];
  for (const message of messages) {
    if (!message.toolInvocations) {
      continue;
    }
    for (const invocation of message.toolInvocations) {
      sessions.push({
        toolCallId: invocation.toolCallId,
        toolName: invocation.toolName,
        state: invocation.state,
        result: invocation.result,
      });
    }
  }
  return sessions;
};

export const hasRenderableMessages = (messages: Message[]): boolean => filterRenderableMessages(messages).length > 0;
